'use strict';

var getDateParamKey = require('./getDateParamKey');

function deleteDateParam(params, key) {
  delete params[getDateParamKey(params, key)];
}

module.exports = deleteDateParam;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/deleteDateParam.js
// module id = 205
// module chunks = 1